import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  ChatContainerView,
  FlaggedMessages,
  MonitorConversation,
} from "./routes";
import Analytics from "./routes/Analytics";
import SearchV2 from "./components/SearchV2";
import { ModuleSettings } from "./components/Settings/routes";
import StaffDirectory from "./routes/StaffDirectory";
export default store => ({
  path: "messaging",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "messaging" */ "./components"),
        import(
          /* webpackChunkName: "messaging" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        injectReducer(store, {
          key: module.NAME,
          reducer: module.default,
        });
        return component;
      })
    // .catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    ..._.map(Analytics, comp => comp(store)),
    MonitorConversation(store),
    SearchV2(store),
    ModuleSettings(store),
    FlaggedMessages(store),
    StaffDirectory(store),
    ChatContainerView(store), // this dynamic route should be at bottom
  ],
});
